import React, { useState } from "react";
import SearchList from "./searchList";
import VendingList from "./vendingList";
import VenueList from "./venueList";
import OrderList from "./orderList";
import { useTranslation } from "react-i18next";

const VenuesComponent = (props) => {
  const { t } = useTranslation();
  const { noList, storesList, orderList, searchList, inputVal, currentData, getLetLongObj, setMapDirection, searchChange,handleOrderModal,handleProductDetailModal } =
    props;
    
  return (
    <>
      <div className="venues-menu">
        <div
          className={`menu ${props.active === 0 ? "active" : null}`}
          onClick={() => props.setActive(0)}
          style={props.active === 0 ? { borderBottom: "3px solid #08BBCF" } : null}
        >
          <div className="img-wrapper" style={{ backgroundColor: "#08BBCF" }}>
            <img
              src={"/assets/icons/stores.png"}
              alt="stores"
            />
          </div>
          <p>{t("user.venues.stores")}</p>
        </div>
        <div
          className={`menu ${props.active === 1 ? "active" : null}`}
          onClick={() => props.setActive(1)}
          style={props.active === 1 ? { borderBottom: "3px solid #F06292" } : null}
        >
          <div className="img-wrapper" style={{ backgroundColor: "#F06292" }}>
            <img
              src={"/assets/icons/vending.png"}
              alt="vending"
            />
          </div>

          <p>{t("user.venues.vendingMachines")}</p>
        </div>
         <div
          className={`menu ${props.active === 2 ? "active" : null}`}
          onClick={() => props.setActive(2)}
          style={props.active === 2 ? { borderBottom: "3px solid #F06292" } : null}
        >
          <div className="img-wrapper" style={{ backgroundColor: "#F06292" }}>
            <img
              src={"/assets/icons/vending.png"}
              alt="vending"
            />
          </div>

          <p>{t("user.venues.online")}</p>
        </div>
        <div
          className={`menu d-none ${props.active === 3 ? "active" : null}`}
          onClick={() => props.setActive(3)}
          style={props.active === 3 ? { borderBottom: "3px solid #F29900" } : null}
        >
          <div className="img-wrapper" style={{ backgroundColor: "#F29900" }}>
            <img
              src={"/assets/icons/search.png"}
              alt="search"
            />
          </div>

          <p>{t("user.venues.search")}</p>
        </div>
      </div>

      {props.active === 0 ? (
        <VenueList
          storesList={storesList}
          currentData={currentData}
          getLetLongObj={(lat, lng) => getLetLongObj(lat, lng)}
          setMapDirection={(ev, store) => setMapDirection(ev, store)}
        />
      ) : props.active === 1 ? (

        // <div className="text-center pt-4" style={{ minHeight: '200px' }}>Coming soon</div>
        <VendingList
          storesList={storesList}
          currentData={currentData}
          getLetLongObj={(lat, lng) => getLetLongObj(lat, lng)}
          setMapDirection={(ev, store) => setMapDirection(ev, store)}
        />
      ): props.active === 2 ? (
        <>
          <div className="search-input-wrapper py-3 px-3">
            <input className="form-control" placeholder={t("user.venues.search")} onChange={(ev) => searchChange(ev.target.value)} value={inputVal} />
          </div>
          <OrderList
          handleOrderModal={handleOrderModal}
            handleProductDetailModal={handleProductDetailModal}
            orderList={orderList}
            currentData={currentData}
            getLetLongObj={(lat, lng) => getLetLongObj(lat, lng)}
            setMapDirection={(ev, store) => setMapDirection(ev, store)}
          />
        </>
      ) : props.active === 3 ? (
        <>
          <div className="search-input-wrapper py-3 px-3">
            <input className="form-control" placeholder={t("user.venues.search")} onChange={(ev) => searchChange(ev.target.value)} value={inputVal} />
          </div>
          <SearchList
            storesList={searchList}
            currentData={currentData}
            getLetLongObj={(lat, lng) => getLetLongObj(lat, lng)}
            setMapDirection={(ev, store) => setMapDirection(ev, store)}
          />
        </>
      ) : null}
    </>
  );
};

export default VenuesComponent;
